/**
 * Typography aligned with bullrun-mobile linked fonts (DM Sans family on iOS/Android).
 *
 * On web, load DM Sans from Google Fonts and use `WEB_FONT_STACK` with numeric
 * `font-weight` (400 / 500 / 700) — see `WEB_FONT_WEIGHT_*`.
 *
 * Desktop bullrun-web uses Inter + JetBrains Mono for the dense "Hot Markets" scale
 * (see `BULLRUN_DENSE_TYPE` and `index.html` font imports).
 */
/** PostScript names bundled in the native app (react-native link / Xcode). */
export const NATIVE_FONT_POSTSCRIPT = {
    regular: "DMSans-Regular",
    medium: "DMSans-Medium",
    bold: "DMSans-Bold",
};
/** CSS font-family stack for mobile-web shell and screens that mirror native. */
export const WEB_FONT_FAMILY_DM_SANS = '"DM Sans", system-ui, -apple-system, sans-serif';
export const WEB_FONT_STACK = {
    /** Prefer for body copy on mobile-web when matching native Regular. */
    regular: `${WEB_FONT_FAMILY_DM_SANS}`,
    medium: `${WEB_FONT_FAMILY_DM_SANS}`,
    bold: `${WEB_FONT_FAMILY_DM_SANS}`,
};
export const WEB_FONT_WEIGHT = {
    regular: 400,
    medium: 500,
    bold: 700,
};
/** Desktop bullrun-web marketing shell (see `index.html`). */
export const WEB_FONT_STACK_INTER = '"Inter", system-ui, -apple-system, sans-serif';
/** Tabular numeric columns on desktop (prices, balances, order book levels). */
export const WEB_FONT_STACK_MONO = '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace';
/**
 * Dense desktop type scale — matches Hot Markets / V01 Bloomberg layout.
 * Spread into styled-components objects; colors are applied at the call site.
 */
export const BULLRUN_DENSE_TYPE = {
    label: {
        fontFamily: WEB_FONT_STACK_INTER,
        fontWeight: 500,
        fontSize: 10,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
    },
    labelSmall: {
        fontFamily: WEB_FONT_STACK_INTER,
        fontWeight: 500,
        fontSize: 10,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
    },
    body: {
        fontFamily: WEB_FONT_STACK_INTER,
        fontWeight: 500,
        fontSize: 12,
    },
    numeric: {
        fontFamily: WEB_FONT_STACK_MONO,
        fontWeight: 500,
        fontSize: 12,
    },
    numericMuted: {
        fontFamily: WEB_FONT_STACK_MONO,
        fontWeight: 400,
        fontSize: 11,
    },
    sectionTitle: {
        fontFamily: WEB_FONT_STACK_INTER,
        fontWeight: 700,
        fontSize: 14,
        lineHeight: "20px",
    },
    tab: {
        fontFamily: WEB_FONT_STACK_INTER,
        fontWeight: 600,
        fontSize: 14,
    },
};
